// ${ApiBase}/customers/
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import moment from 'moment'
import { formatPhoneNumber } from 'react-phone-number-input'

import ElationIcon from '@/components/ElationIcon'
import { CustomerListResponse, CustomerParams } from '@/types/customer'
import { buildPhoneNumberValue } from '@/ui/SingleLinePhone'

export const loadCustomersToSelect = async (params: CustomerParams) => {
  const response: CustomerListResponse = await makeGetRequest(
    ApiBase + '/customers',
    {
      params,
    }
  )

  return response.results.map((item) => {
    let dateOfBirth
    let phoneNumber

    if (item?.date_birth) {
      dateOfBirth = moment(item?.date_birth).format('MM/DD/YYYY')
    }

    if (item?.phone_number) {
      phoneNumber = formatPhoneNumber(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        buildPhoneNumberValue(item?.phone_number)
      )
    }

    return {
      searchBy: [item.first_name, item.last_name, item.email]
        .filter(Boolean)
        .join(' '),
      raw_label: [item?.first_name, item?.last_name].filter(Boolean).join(' '),
      label: (
        <div className="flex w-full flex-col">
          <h3 className="flex items-center gap-2 text-base font-medium">
            {[item?.first_name, item?.last_name].filter(Boolean).join(' ')}
            {item?.is_linked_to_elation ? (
              <i className="-mt-1">
                <ElationIcon />
              </i>
            ) : null}
          </h3>
          <span className="w-full text-sm text-gray-500">
            {[item?.email, phoneNumber, dateOfBirth].filter(Boolean).join(', ')}
          </span>
        </div>
      ),
      value: Number(item.id),
      title: {
        first_name: item.first_name,
        last_name: item.last_name,
        middle_name: item.middle_name,
        id: Number(item.id),
        date_birth: item.date_birth,
        email: item.email,
        phone_number: item.phone_number,
      },
    }
  })
}
